<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <custom-popup
        v-model="dialog"
        :cons="{
          title: $t('feedbacks'),
        }"
        hide-confirm
        max-width="1024"
        @close="resetFields"
      >
        <v-card class="pa-4" flat>
          <v-progress-linear v-show="loading" class="mb-2" indeterminate />
          <custom-tabs v-model="tabs" grow>
            <template v-slot:staticTabs>
              <v-tab :ripple="false">
                <div class="cornel-left"></div>
                <div class="cornel-right"></div>
                <div
                  class="d-flex row"
                  style="
                    justify-content: center !important;
                    align-items: center;
                  "
                >
                  <v-icon class="me-2">mdi-plus</v-icon>
                  {{ $t("feedbacks") }}
                  <help-info
                    :element-name="`${serviceName}-${componentName}-added`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('feedbacks')"
                  />
                </div>
              </v-tab>

              <v-tab :ripple="false">
                <div class="cornel-left"></div>
                <div class="cornel-right"></div>
                <div
                  class="d-flex row"
                  style="
                    justify-content: center !important;
                    align-items: center;
                  "
                >
                  <v-icon class="me-2">mdi-plus</v-icon>
                  {{ $t("add") }}
                  <help-info
                    :element-name="`${serviceName}-${componentName}-added`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('add')"
                  />
                </div>
              </v-tab>

              <v-tab :ripple="false" style="justify-content: center !important">
                <div class="cornel-left"></div>
                <div class="cornel-right"></div>
                <div
                  class="d-flex row"
                  style="
                    justify-content: center !important;
                    align-items: center;
                  "
                >
                  <v-icon class="me-2">mdi-cogs</v-icon>
                  {{ $t("header_color_settings") }}
                  <help-info
                    :element-name="`${serviceName}-${componentName}-color-text-setting`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('header_color_settings')"
                  />
                </div>
              </v-tab>
            </template>

            <template v-slot:middle>
              <div class="py-2"></div>
            </template>

            <template v-slot:staticItems>
              <v-tab-item>
                <list-feedback-user
                  :info="info"
                  :data="info.data.data.FeedBack"
                  v-model="info.data.data.FeedBack"
                  :dialogs="dialog"
                  :key="$i18n.locale + '-feedback-list'"
                />
              </v-tab-item>
              <v-tab-item>
                <feed-back
                  :info="info"
                  :data="info.data.data.FeedBack"
                  v-model="info.data.data.FeedBack"
                  :dialogs="dialog"
                  :key="$i18n.locale + '-feedback-add'"
                ></feed-back>
              </v-tab-item>
              <v-tab-item>
                <galleries-texts
                  v-model="info.data.data.FeedBack"
                  :be-grid="false"
                  :both="false"
                  :secondPosition="false"
                  :just-color="true"
                  :key="$i18n.locale + '-feedback-color'"
                />
              </v-tab-item>
            </template>
          </custom-tabs>
        </v-card>
      </custom-popup>
    </template>
  </help-info-wrapper>
</template>

<script>
import FeedBack from "../../components/Comment/FeedBack.vue";
import GalleriesTexts from "../businessPage/components/view/galleriesTexts.vue";
import listFeedbackUser from "./components/listFeedbackUser.vue";

export default {
  components: { FeedBack, GalleriesTexts, listFeedbackUser },
  name: "qrFeedbackList",

  props: {
    value: Boolean,
    address: String,
  },

  data() {
    return {
      info: {},
      helpData: [],
      serviceName: "Qrland",
      componentName: "qrFeedback-list",
      tabs: 0,
      feedbacks: [],
      loading: false,
    };
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        
        this.$emit("input", val);
      },
    },
    url() {
      return this.info.domain?.name + this.info.identifier;
    },
  },
  mounted() {
    this.$emit("fetch");
    // this.fetch();
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    value(val) {
      if (val) {
        setTimeout(() => {
            this.fetch();
        }, 300);
      }
    },
  },

  methods: {
    fetch() {
      // if (!this.info?.domain?.name || !this.info?.identifier) {
      //   console.warn("Missing QR info", this.info);
      //   return;
      // }
      if (!this.address) {
        console.warn("Missing QR address", this.address);
        return;
      }
      this.loading = true;
      this.$api
        .get(
          `/v1/testQr/find/${this.address}`,
        )
        .then(({ data }) => {
          this.feedbacks = data.data.data.FeedBack;
          this.info = data.data
          console.log("fetching feedback:", data.data);
        })
        .catch(({ response }) => {
          console.log("Error fetching feedback:", response);
          this.$toast.error(this.$t("failed_retrieve_feedback"));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetFields() {
      this.feedbacks = [];
    },
  },
};
</script>

<style scoped></style>
